import React from "react";
import { ValueLabel } from "@features/ax/shared/ValueLabel";
import BadgeList from "@shared/components/BadgeList";

const OverviewTab = ({ readCycleData }: { readCycleData: any }) => {
  const productCodes = Array.isArray(readCycleData?.productCode)
    ? readCycleData.productCode.join(", ")
    : readCycleData?.productCode || "—";

  const overviewSections = [
    {
      title: "Basic Information",
      items: [
        {
          label: "Cycle Name",
          value: readCycleData?.meterCycleName || "N/A",
        },
        {
          label: "Utility Services",
          value: productCodes,
        },
        {
          label: "Category",
          value: readCycleData?.categoryName || "N/A",
        },
        {
          label: "Sub Category",
          value: readCycleData?.subCategoryName || "N/A",
        },
      ],
    },
    {
      title: "Operation Details",
      items: [
        {
          label: "Resource Type",
          value: <BadgeList items={readCycleData?.resourceTypeDisplay || []} />
        },
        {
          label: "Resource Sub Type",
          value: <BadgeList items={readCycleData?.resourceSubTypeDisplay || []} />
        },
        {
          label: "Data Collection Method",
          value: readCycleData?.dataCollectionMethodName || "N/A",
        },
        {
          label: "Read Format",
          value: readCycleData?.readFormatName || "N/A",
        },
      ],
    },
    {
      title: "Schedule Configuration",
      items: [
        {
          label: "Frequency",
          value: readCycleData?.frequencyDisplay || "N/A",
        },
        {
          label: "Start Date",
          value: readCycleData?.startDate || "N/A",
        },
        {
          label: "Start Time",
          value: readCycleData?.startTime || "—",
        },
        {
          label: "Schedule End Date",
          value:
            readCycleData?.scheduleEndDate || readCycleData?.endDate || "—",
        },
      ],
    },
  ];

  return (
    <div className="space-y-6">
      {overviewSections.map((section) => (
        <div key={section.title} className="space-y-3">
          <h3 className="text-xs font-semibold text-gray-500 tracking-wide">
            {section.title}
          </h3>
          <div className="border border-gray-200 rounded-xl p-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-5 gap-x-12">
              {section.items.map((item) => (
                <ValueLabel
                  key={item.label}
                  label={item.label}
                  value={item.value}
                />
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OverviewTab;
